import { BrokersRequiredPaymentInfoAutopayState } from 'utils/web_api.schemas'

import { type RequirePaymentsQueryParameters } from './types'

export function getRequiredPaymentsDefaultQueryParams ({ forMonth, forYear }: {
  forMonth?: RequirePaymentsQueryParameters['forMonth'] | undefined,
  forYear?: RequirePaymentsQueryParameters['forYear'] | undefined,
} = {}): RequirePaymentsQueryParameters {
  const currentDate = new Date()
  return {
    autopayStates: Object.values(BrokersRequiredPaymentInfoAutopayState),
    excludedCarrierNames: [],
    forMonth: forMonth ?? currentDate.getMonth() + 1, // JavaScript months are 0-indexed
    forYear: forYear ?? currentDate.getFullYear(),
    includedCarrierNames: [],
  }
}

export function getManualPaymentsQueryParams ({ automatedCarriers, forMonth, forYear }: {
  automatedCarriers: RequirePaymentsQueryParameters['excludedCarrierNames'],
  forMonth?: RequirePaymentsQueryParameters['forMonth'] | undefined,
  forYear?: RequirePaymentsQueryParameters['forYear'] | undefined,
}): RequirePaymentsQueryParameters {
  const currentDate = new Date()
  return {
    autopayStates: [BrokersRequiredPaymentInfoAutopayState.off],
    excludedCarrierNames: automatedCarriers,
    forMonth: forMonth ?? currentDate.getMonth() + 1, // JavaScript months are 0-indexed
    forYear: forYear ?? currentDate.getFullYear(),
    includedCarrierNames: [],
  }
}
